import Component from '../core/Component'

export default class History extends Component {
    constructor(element) {
        super(element)

        this.index = 0
        this.ref = {
            items: [],
            controlItems: [],
            years: [],
        }
    }

    prepare() {
        this.render()

        this.ref.controlItems.forEach((item, index) => {
            item.addEventListener('click', event => {
                this.index = index
                this.render()
            })
        })

        this.ref.years.forEach(item => {
            item.innerHTML = item.textContent
                .split('')
                .map(letter => `<span>${letter}</span>`)
                .join('')
        })
    }

    render() {
        this.ref.items.forEach(item => item.classList.remove('is-active'))
        this.ref.controlItems.forEach(item => item.classList.remove('is-active'))
        this.ref.items[this.index].classList.add('is-active')
        this.ref.controlItems[this.index].classList.add('is-active')
    }
}